import { axios } from './axios';
import {_url} from '../utils/http.util';
export default {
    _callback: null,
    _callbackError: null,
    then(callback){
        this._callback = callback;
        return this;
    },
    catch(callback){
        this._callbackError = callback;
        return this;
    },
    success(data){
        if(typeof this._callback === 'function') this._callback(data);
    },
    error(error){
        if(typeof this._callbackError === 'function') this._callbackError(error);
    },
    get(url){
        axios.get(_url(url))
        .then(response => this.success(response.data))
        .catch(error => this.error(error));
    },
    post(url, payload){
        axios.post(_url(url), payload)
        .then(response => this.success(response.data))
        .catch(error => this.error(error));
    },
    delete(url){
        axios.delete(_url(url))
        .then(response => this.success(response.data))
        .catch(error => this.error(error));
    },
    put(url, payload){
        axios.put(_url(url), payload)
        .then(response => this.success(response.data))
        .catch(error => this.error(error));
    },
    querify(params){
        if(!params || !Object.keys(params).length) return '';

        const arrParams = [];
        Object.keys(params).map(key => (typeof params[key] !== 'undefined' && params[key] !== '') && arrParams.push(`${key}=${params[key]}`));
        const queryString = '?' + arrParams.join('&');
        return queryString;
    }
}

